<template>
  <v-container class="py-10" fluid>
    <v-row align="center" justify="center">
      <h1>Communities</h1>
    </v-row>
    <v-row align="center" justify="center">
      <v-col class="d-flex align-center justify-center" cols="12" sm="12" md="5" lg="5" xl="5">
        <v-text-field :disabled="loadingClubs" prepend-icon="fa-search"
                      placeholder="Search by any field..." v-model="search"/>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="10" md="11" sm="12" xl="10">
        <v-data-table :headers="headers" :items="items" :search="search" :loading="loadingClubs" loading-text="Loading Clubs...">
          <template v-slot:item.createdAt="{ item }">
            <p class="my-0">{{ item.createdAt.substr(0, 10) }}</p>
          </template>
          <template v-slot:item.proExpirationTime="{ item }">
            <p class="my-0">{{ item.proExpirationTime.substr(0, 10) }}</p>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon @click="showClub(item)" class="icon">fa-eye</v-icon>
            <v-icon @click="editClub(item)" class="icon" small>fa-certificate</v-icon>
            <v-icon @click="showBatches(item)" class="icon" small>fa-stream</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-overlay v-model="overlayShowClubInfo">
      <ShowClubInfo :club="selectedClub" @closeWindow="overlayShowClubInfo = false"/>
    </v-overlay>
    <v-overlay v-model="overlayEditClub">
      <EditClub :club="selectedClub" @proDateEdited="proDateEdited" @closeWindow="overlayEditClub = false"/>
    </v-overlay>
    <v-overlay v-model="overlayClubBatches">
      <ClubBatches :club="selectedClub" @createdBatch="createdBatch" @closeWindow="overlayClubBatches = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../repositories/club';
import ShowClubInfo from "@/views/Clubs/components/ShowClubInfo";
import EditClub from "@/views/Clubs/components/EditClub";
import ClubBatches from "@/views/Clubs/components/ClubBatches";

export default {
  name: "Clubs",
  components: {
    ShowClubInfo,
    EditClub,
    ClubBatches
  },
  data() {
    return {
      loadingClubs: false,
      search: '',
      headers: [
        {text: 'Club Name', value: 'name', align: 'left', sortable: true, filterable: true},
        {text: 'Creation Date', value: 'createdAt', align: 'left', sortable: true, filterable: true},
        {text: 'Pro Expiration', value: 'proExpirationTime', align: 'left', sortable: true, filterable: true},
        {text: 'Threshold', value: 'threshold', align: 'left', sortable: true, filterable: true},
        {text: 'Actions', value: 'actions', align: 'left', sortable: false, filterable: true}
      ],
      items: [],

      selectedClub: null,
      overlayShowClubInfo: false,
      overlayEditClub: false,
      overlayClubBatches: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadingClubs = true;
      Repository.allClubs().then((response) => {
        if (response.status < 400) {
          this.items = response.data;
          this.loadingClubs = false;
        }
      });
    },
    showClub(club) {
      this.selectedClub = club;
      this.overlayShowClubInfo = true;
    },
    editClub(club) {
      this.selectedClub = club;
      this.overlayEditClub = true;
    },
    showBatches(club) {
      this.selectedClub = club;
      this.overlayClubBatches = true;
    },
    createdBatch() {
      this.init();
      this.overlayClubBatches = false;
    },
    proDateEdited() {
      this.init();
      this.overlayEditClub = false;
    }
  },
};
</script>

<style scoped>

</style>